<template>
    <component :is="tag">
        <slot :on-play-video="onPlayVideo" />
    </component>
</template>

<script>
    import GLightbox from 'glightbox';
    import 'glightbox/dist/css/glightbox.css';

    export default {
        props: {
            tag: {
                type: String,
                default: 'div',
            },
        },

        data() {
            return {
                lightbox: null,
            };
        },

        mounted() {
            this.lightbox = GLightbox({
                touchNavigation: true,
                loop: true,
                autoplayVideos: true,
            });

            const searchParams = new URLSearchParams(location.search);
            if (searchParams.has('video')) {
                this.onPlayVideo(searchParams.get('video'));
            }
        },

        methods: {
            onPlayVideo(url) {
                let source = 'local';
                if (url.includes('vimeo') || url.includes('youtu')) {
                    source = url.includes('vimeo') ? 'vimeo' : 'youtube';
                }

                const gallery = GLightbox({
                    elements: [
                        {
                            href: url,
                            type: 'video',
                            source,
                            width: 900,
                        },
                    ],
                    autoplayVideos: true,
                });

                gallery.open();
            },
        },
    };
</script>
